module.exports = __webpack_public_path__ + "img/pickup_summary.6220cf02.svg";